import { InvoiceData, InvoiceStatusType, InvoiceTransactionActionType, InvoiceType } from 'types/invoices';
import { useInvoice } from './useInvoice';

type InvoiceFlowActions = {
    isRequestedToPostpone: boolean;
    isPostponeDisagreedContinued: boolean;
    isPostponeRejected: boolean;
    isInvoiceRejected: boolean;
    hasFlowAlerts: boolean;
    isPostponeConfirmed: boolean;
};

export const useInvoiceFlow = (invoice: InvoiceData): InvoiceFlowActions => {
    const { isFinalized } = useInvoice(invoice);

    const isRequestedToPostpone =
        invoice.invoiceTypeCode === InvoiceType.DEBIT &&
        invoice.invoiceStatusTypeCode === InvoiceStatusType.REVIEWED &&
        !!invoice.invoiceTransitions?.length &&
        invoice.invoiceTransitions[0].invoiceTransitionActionType === InvoiceTransactionActionType.POSTPONED;

    const isPostponeDisagreedContinued =
        invoice.invoiceTypeCode === InvoiceType.DEBIT &&
        invoice.invoiceStatusTypeCode === InvoiceStatusType.REVIEWED &&
        invoice.invoiceTransitions?.length > 1 &&
        invoice.invoiceTransitions[0].invoiceTransitionActionType === InvoiceTransactionActionType.REJECTED &&
        invoice.invoiceTransitions[1].invoiceTransitionActionType === InvoiceTransactionActionType.POSTPONED;

    const isPostponeRejected =
        invoice.invoiceTypeCode === InvoiceType.DEBIT &&
        invoice.invoiceStatusTypeCode === InvoiceStatusType.DRAFT &&
        invoice.invoiceTransitions?.length > 1 &&
        invoice.invoiceTransitions[0].invoiceTransitionActionType === InvoiceTransactionActionType.REJECTED &&
        invoice.invoiceTransitions[1].invoiceTransitionActionType === InvoiceTransactionActionType.POSTPONED;

    const isPostponeConfirmed =
        invoice.invoiceTypeCode === InvoiceType.DEBIT && invoice.invoiceStatusTypeCode === InvoiceStatusType.POSTPONED;

    const isInvoiceRejected =
        !isFinalized &&
        invoice.invoiceTransitions?.length > 1 &&
        invoice.invoiceTransitions[0].invoiceTransitionActionType === InvoiceTransactionActionType.REJECTED &&
        invoice.invoiceTransitions[1].invoiceTransitionActionType !== InvoiceTransactionActionType.POSTPONED;

    const hasFlowAlerts =
        isRequestedToPostpone ||
        isPostponeDisagreedContinued ||
        isPostponeRejected ||
        isInvoiceRejected ||
        isPostponeConfirmed;

    return {
        isRequestedToPostpone,
        isPostponeDisagreedContinued,
        isPostponeRejected,
        isInvoiceRejected,
        isPostponeConfirmed,
        hasFlowAlerts,
    };
};
